import { connect } from 'react-redux';
import { PaymentCard } from '@lt/components';

// Hocs:
import withMobile from '../hocs/withMobile';

// Actions:
import {
  setCardDataAction,
  setCardValidityAction,
} from '../../../store/payment/slice';

// Selectors:
import { getCardData } from '../../../store/payment/selectors';

const mapStateToProps = (state) => ({
  defaultValue: getCardData(state),
});

const mapDispatchToProps = (dispatch) => ({
  onChange: (cardFields) => dispatch(setCardDataAction(cardFields)),
  onValidationChanged: (isValid) => dispatch(setCardValidityAction(isValid)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withMobile(PaymentCard));
